import * as d3 from "d3";

import { interpolateColors } from "../../../helpers/colorGenerator";

const package_chart_data = (data) => {
  var colorScale = d3.interpolateHclLong("#7d5fff", "#ff6348");

  return {
    datasets: [
      {
        data: data.items,
        backgroundColor: interpolateColors(data.items.length, colorScale, {
          colorStart: 0,
          colorEnd: 1,
          useEndAsStart: true,
        }),
      },
    ],
    labels: data.items.some((x) => x > 0) ? data.labels : [],
  };
};

export default package_chart_data;
